<template>
    <el-popover
        placement="left"
        width="280"
        trigger="click"
        :disabled="!(executado == 1)"
        v-model="visible"
    >
        <div style="text-align: center; padding: 5px;">
            <p style="font-size: 14px; font-weight: bold; margin-bottom: 15px; color: #333;">
                Enviar Relatório Executado <br> OS {{ idOs }}
            </p>
            <vs-button 
                color="primary" 
                type="border" 
                icon="mail" 
                style="width: 100%; margin-bottom: 8px;"
                @click="enviarRelatorioExecutado(2)"
            >
                Enviar por Email
            </vs-button>
            <vs-button 
                color="success" 
                type="border" 
                icon="chat" 
                style="width: 100%; margin-bottom: 8px;"
                @click="enviarRelatorioExecutado(3)"
            >
                Enviar por WhatsApp
            </vs-button>
            <vs-button 
                color="dark" 
                type="border" 
                icon="done_all" 
                style="width: 100%;"
                @click="enviarRelatorioExecutado(1)"
            >
                Enviar Ambos
            </vs-button>
        </div>
        <vs-button
            slot="reference"
            class="px-0 py-0 m-0"
            icon="send"
            :disabled="!(executado == 1)"
            color="primary"
            size="small"
            type="filled"
        ></vs-button>
    </el-popover>
</template>
<script>
    export default {
        name: "EnviarRelatorioOs",
        data() {
            return {
                visible: false
            }
        },
        props: {
            idOs: {
                type: Number,
                default: 0
            },
            executado: {
                type: Number,
                default: 0
            },
            divLoading: {
                type: String,
                default: ''
            }
        },
        methods: {
            async enviarRelatorioExecutado(tipoEnvio){
                this.visible = false;
                try{
                    this.$vs.notify({
                        color: "dark",
                        title: "Enviando...",
                        text: "Por favor, aguarde enquanto o relatório é processado e enviado.",
                        time: 4000
                    })
                    
                    if (this.divLoading != ''){
                        this.$vs.loading({ container: `#${this.divLoading}` })
                    } else {
                        this.$vs.loading() // Fallback: mostra o loading na tela inteira se a div não for especificada
                    }
                    
                    const payload = {
                        idOs : this.idOs,
                        tipoEnvio
                    }
                    let res = await this.$http.post(`enviarRelatorioOSExecutado`, payload)
                    res = res.data

                    if (tipoEnvio === 3 && !res.whatsapp.sucesso){
                        throw new Error(`Erro ao enviar por Whatsapp: ${res.whatsapp.erro || 'Erro interno do servidor'}`)
                    }

                    if (tipoEnvio === 2 && !res.email.sucesso){
                        throw new Error(`Erro ao enviar por Email: ${res.email.erro || 'Erro interno do servidor'}`)
                    }

                    if (tipoEnvio === 1){
                        if (!res.email.sucesso && !res.whatsapp.sucesso){
                            throw new Error("Erro ao enviar relatório por email e whatsapp")
                        }

                        if (res.email.sucesso && !res.whatsapp.sucesso){
                            this.$vs.notify({ color: "dark", title: `Relatório enviado por email, mas erro ao enviar por whatsapp: ${res.whatsapp.erro}.` })
                            return
                        }

                        if (!res.email.sucesso && res.whatsapp.sucesso){
                            this.$vs.notify({ color: "dark", title: `Relatório enviado por whatsapp, mas erro ao enviar por email: ${res.email.erro}.` })
                            return
                        }
                    }

                    this.$vs.notify({ color: "success", title: "Relatório enviado com sucesso" })
                }catch(erro){
                    console.log(erro)
                    this.$vs.notify({ color: "danger", title: erro.message })
                }finally{
                    if (this.divLoading != ''){
                        this.$vs.loading.close(`#${this.divLoading} > .con-vs-loading`)
                    } else {
                        this.$vs.loading.close() // Fecha o loading global se tiver sido usado
                    }
                }
            }
        }
    }
</script>